module.exports = __webpack_public_path__ + "img/s3-3.e185ab0c.jpg";